<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <p class="mb-4" id="create_report_message">Reports you have set up to be sent to you on a schedule are listed here. To set up reports on a schedule, please specify that option on the Reporting/Analytics tab of a license pool or group</p>
            <div v-if="reports!==null">
              <div class="mt-2" v-if="reports.length===0" id="no_saved_reports">
                You have no saved reports
              </div>
              <div class="row mt-2" v-if="reports.length>0">
                <div class="col-3">
                  <b id="license_pool_name">License Pool Name</b>
                </div>
                <div class="col-3">
                  <b id="type">Type</b>
                </div>
                <div class="col-2">
                  <b id="frequency">Frequency</b>
                </div>
                <div class="col-4">
                  &nbsp;
                </div>

              </div>
              <div class="row mt-2" v-for="report in reports" v-if="reports.length>0">
                <div class="col-3">
                  {{report.LicensePoolName}}
                </div>
                <div class="col-3">
                  {{report.RType}}
                </div>
                <div class="col-2">
                  {{report.TFreq}}
                </div>


                <div class="col-4">
                  <button class="btn btn-secondary btn-short nopadding smallheight" @click="doRemove(report.ClientReportID)" id="remove">Remove</button>
                </div>
              </div>

              <div class="row mt-4" v-show="apools!==null&&apools.length>1">
                  <div class="col-6">
                     <select v-model="crpool" class="fullWidth" id="ddlCreateReport">
                        <option v-for="pool in apools" v-bind:value="pool.LicensePoolID">{{pool.LicensePoolName}}</option>
                     </select>
                  </div>
                  <div class="col-6">
                     <button class="btn btn-primary btn-short" @click="doCreateReport" id="create_report">Create Report</button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>

  </div>
 
</template>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"

  export default {
      name: 'Reports',
      components: {acheader,acfooter,clientsidebar},
      data() {
        return {
          apools:null,
          crpool:null,
          reports:null
        }
      },
      methods: {
        doCreateReport() {
          if (this.crpool!==null) {
            this.$router.push("/pool/"+this.crpool+"/reporting")
          }
        },
        doRemove(cprid) {
          this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this report schedule?', {
            title: 'Confirm Removal',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }).then(value => {
            if (value) {
              this.apiCommand([
                {
                  Operation: "LicensePool",
                  Function: "RemoveClientReport",
                  Fields: {
                    ClientReportID: cprid
                  }
                }
              ]).then(r=>{
   
                this.popDialog(0, "Report Removed Successfully");
                this.render();            
              });
            }
          });
        },
        render() {
          this.apiCommand([{
            Operation: "LicensePool",
            Function: "GetClientReports",
            Fields:{}
          }]).then(r=>{
            var cr=JSON.parse(r.CommandResult);
            this.reports=JSON.parse(cr.returnObjects[0].returnObject);
            for(var report of this.reports) {
       
              if (report.Frequency===1) {
                report.TFreq="Daily";
              }
              if (report.Frequency===2) {
                report.TFreq="Weekly";
              }
              if (report.Frequency===3) {
                report.TFreq="Monthly";
              }
              if (report.Frequency===4) {
                report.TFreq="Quarterly";
              }
              if (report.Frequency===5) {
                report.TFreq="Semi-Annually";
              }
              if (report.Frequency===6) {
                report.TFreq="Annually";
              }

              if (report.ReportType===0) {
 
                var p = JSON.parse(report.Parameters.replace(/&quot;/g,'"'));
                if (p.ProductID!==this.emptyguid && p.ProductID!==null) {
                  report.RType="Product";
                }
                else {
                  report.RType="Member/Group";
                }
              }
              else if (report.ReportType===1) {
                report.RType="Training Plan";
              }
              else if (report.ReportType===2) {
                report.RType="Group Comparison";
              }
              else {
                report.RType="Transcript Analytics";
              }
            }
          });
        }
      },
      mounted() {
        this.doPage().then(r=>{

          this.bootstrapClient(this.$route.params.id);
          this.apools=this.sdata.allpools;
          this.apools.unshift({
            LicensePoolID: null,
            LicensePoolName: "--- Select ---"
          })
          this.render();
         

        });
      }
   }
</script>
